import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './QuestionStep.css';

const ElectricityBillStep = ({ value, onChange }) => {
  const [inputValue, setInputValue] = useState(value || '');

  const handleChange = (e) => {
    const val = e.target.value.replace(/[^0-9]/g, '');
    setInputValue(val);
    onChange(val ? parseInt(val) : null);
  };

  return (
    <div className="question-step">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
      >
        <h2 className="question-title">What's your current monthly electricity bill?</h2>
        <p className="question-subtitle">Enter your average monthly bill amount</p>
      </motion.div>

      <motion.div
        className="input-container"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        <div className="bill-input-wrapper">
          <span className="currency-symbol">₹</span>
          <input
            type="text"
            className="bill-input"
            placeholder="Enter amount"
            value={inputValue}
            onChange={handleChange}
            autoFocus
          />
        </div>

      </motion.div>

      <motion.div
        className="bill-highlights"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
      >
        <div className="highlight-pill">
          <span className="highlight-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 1v22" />
              <path d="M5 5h7a5 5 0 0 1 0 10H9" />
              <path d="M9 15h6a5 5 0 0 1 0 10H5" />
            </svg>
          </span>
          <div className="highlight-copy">
            <span className="highlight-title">₹1 Down EMI Promise</span>
            <span className="highlight-sub">Projected EMI stays below your current electricity spend</span>
          </div>
        </div>

        <div className="highlight-pill">
          <span className="highlight-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              <path d="M9 12l2 2 4-4" />
            </svg>
          </span>
          <div className="highlight-copy">
            <span className="highlight-title">Subsidy & Warranty Ready</span>
            <span className="highlight-sub">Government incentives and 25-year coverage built in</span>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default ElectricityBillStep;

